/* tslint:disable */
/* eslint-disable */
/**
 * KGH PROJECT API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * DbConnectionHealthApi - axios parameter creator
 * @export
 */
export const DbConnectionHealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDbConnectionSchemaGet: async (schema: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('apiDbConnectionSchemaGet', 'schema', schema)
            const localVarPath = `/api/db-connection/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DbConnectionHealthApi - functional programming interface
 * @export
 */
export const DbConnectionHealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DbConnectionHealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDbConnectionSchemaGet(schema: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDbConnectionSchemaGet(schema, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DbConnectionHealthApi - factory interface
 * @export
 */
export const DbConnectionHealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DbConnectionHealthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDbConnectionSchemaGet(schema: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDbConnectionSchemaGet(schema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDbConnectionSchemaGet operation in DbConnectionHealthApi.
 * @export
 * @interface DbConnectionHealthApiApiDbConnectionSchemaGetRequest
 */
export interface DbConnectionHealthApiApiDbConnectionSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DbConnectionHealthApiApiDbConnectionSchemaGet
     */
    readonly schema: string
}

/**
 * DbConnectionHealthApi - object-oriented interface
 * @export
 * @class DbConnectionHealthApi
 * @extends {BaseAPI}
 */
export class DbConnectionHealthApi extends BaseAPI {
    /**
     * 
     * @param {DbConnectionHealthApiApiDbConnectionSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DbConnectionHealthApi
     */
    public apiDbConnectionSchemaGet(requestParameters: DbConnectionHealthApiApiDbConnectionSchemaGetRequest, options?: AxiosRequestConfig) {
        return DbConnectionHealthApiFp(this.configuration).apiDbConnectionSchemaGet(requestParameters.schema, options).then((request) => request(this.axios, this.basePath));
    }
}
